import React, { FC } from 'react';

import Button from '@wetransfer/transfer/component/form/element/button';

interface Props {
  actionText: string;
  subtitle: string;
  title: string;
  link?: string;
  linkAction(): void;
  action(): void;
}

const AccountWarning: FC<Props> = ({
  actionText,
  subtitle,
  title,
  link = null,
  linkAction,
  action,
}) => (
  <div className="accountwarning">
    <h2>{title}</h2>
    <p>
      {subtitle}
      {link && (
        <>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href="javascript:void(0)"
            onClick={linkAction}
            className="revert-link"
          >
            {' '}
            {link}
          </a>
        </>
      )}
    </p>
    <Button
      className="accountwarning__action"
      type="inline"
      onClick={action}
      text={actionText}
    />
  </div>
);

export default AccountWarning;
